import * as React from 'react';
import cn from 'clsx';

import { IWithDeviceTypeProps, withDeviceType } from '../../../../utils/withDeviceType';

import * as styles from './styles.css';

const DealStepModalCardList: React.FC<React.PropsWithChildren<IWithDeviceTypeProps>> = props => {
  return <ul className={cn(styles['list'], styles[props.deviceType])}>{props.children}</ul>;
};

const DealStepModalCardListWithDeviceType = withDeviceType(DealStepModalCardList);
export { DealStepModalCardListWithDeviceType as DealStepModalCardList };
